import React, { useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';

import { CssBaseline } from '@material-ui/core';

import { BastionContext } from 'context';

import Footer from 'components/Footer';
import Header from 'components/Header';
import Sidebar from 'components/Sidebar';
import useStyles from './layout.styled';

import { uiActions } from 'state/modules/UI';
import AppBreadcrumbs from '../AppBreadCrumbs';
import { useLocation, useHistory } from 'react-router-dom';
import { buildUrl } from 'utils';

const Layout = ({ children, title }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();

  const { theme } = useContext(BastionContext);

  const { sidebarOpen } = useSelector((state) => state.ui);

  const location = useLocation();

  const { unauthorized } = useSelector((state) => state.auth);

  const handleDrawerOpen = () => {
    dispatch(uiActions.handleShowSidebar(!sidebarOpen));
  };

  useEffect(() => {
    if (unauthorized && history) {
      history.push(buildUrl('/404'));
    }
  }, [unauthorized]);

  return (
    <div className={classes.root}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`${title ? title : theme.page.title}`}</title>
        <link rel="icon" type="image/png" href={theme.page.favicon} sizes="16x16" />
      </Helmet>
      <CssBaseline />
      <Header classes={classes} />
      <Sidebar open={sidebarOpen} handleDrawerOpen={handleDrawerOpen} />
      <main className={classes.content}>
        {!['/dashboard', '/reservations'].includes(location.pathname) ? <AppBreadcrumbs /> : null}
        {children}
        <Footer />
      </main>
    </div>
  );
};

export default Layout;
